import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ButtonProps, IconButton, Stack, Tooltip} from '@mui/material';
import IconPlay from '../../asset/icons/icon_play.svg';
import IconPause from '../../asset/icons/icon_pause.svg';
import IconNoPlay from '../../asset/icons/icon_close.svg';
import {playSong, togglePlayerState} from '../../store/Slices/playerSlice';
import {RootState} from '../../store/configstore';
import DownloadButton from '../Button/DownloadButton';

type Props = {
  id: string | number | null;
  url: string;
  size?: boolean;
  track_name: string;
  track_artist: string;
  buttonProps?: ButtonProps;
  toolTipLabel?: string;
  isDownloadable?: boolean;
  downloadFileName?: string;
};

const MusicPreviewBtn = ({
  id,
  url,
  size,
  track_name,
  track_artist,
  buttonProps,
  toolTipLabel = '',
  isDownloadable = false,
  downloadFileName = '',
}: Props) => {
  const dispatch = useDispatch();

  const {
    songUrl,
    id: currentId,
    isPlaying,
  } = useSelector((state: RootState) => state.player);

  const sizeSet = size ? {width: '29px', height: '29px'} : {};

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (songUrl === url && currentId === id) {
      dispatch(togglePlayerState());
    } else {
      dispatch(playSong({songUrl: url, track_name, track_artist, id: id || 0}));
    }
  };

  const isPlayCurrentSong = isPlaying && currentId === id;

  return (
    <Tooltip title={toolTipLabel} describeChild>
      <Stack direction='row' className='items-center gap-1'>
        <IconButton
          className='p-0'
          aria-label={isPlayCurrentSong ? 'pause' : 'play'}
          onClick={handleClick}
          {...buttonProps}
          disabled={!url?.trim()}>
          <img
            src={isPlayCurrentSong ? IconPause : IconPlay}
            alt=''
            style={sizeSet}
          />
        </IconButton>
        {isDownloadable && (
          <DownloadButton filename={downloadFileName || track_name} url={url} />
        )}
      </Stack>
    </Tooltip>
  );
};

export default MusicPreviewBtn;

export const MusicPreviewBtnDisable = ({isNoPlay}: {isNoPlay?: boolean}) =>
  isNoPlay ? (
    <img src={IconNoPlay} alt='No Play' className='w-20' />
  ) : (
    <IconButton aria-label='play' disabled={true}>
      <img src={IconPlay} alt='' />
    </IconButton>
  );
